import { LogLevel } from 'bitmovin-player';
import { isSafari } from '../../utilities/utilities.user-agent';
export function processPlayerConfig(npoplayer, playerConfig) {
    const processedConfig = playerConfig;
    if (isSafari()) {
        processedConfig.playback = {
            autoplay: false
        };
        processedConfig.tweaks = {
            fairplay_ignore_duplicate_init_data_key_errors: true
        };
    }
    processedConfig.ui = false;
    const defaultRemoteControlConfig = {
        type: 'googlecast',
        receiverApplicationId: 'CC38EB17',
        receiverVersion: 'v3',
        messageNamespace: 'urn:x-cast:com.bitmovin.player.caf',
        customReceiverConfig: {
            drm: npoplayer.drmProfile.drm,
            profileName: npoplayer.drmProfile.profileName,
            jwt: npoplayer.jwt
        }
    };
    const userRemoteControlConfig = processedConfig.remotecontrol || defaultRemoteControlConfig;
    const mergedRemoteControlConfig = {
        ...defaultRemoteControlConfig,
        ...userRemoteControlConfig,
        customReceiverConfig: {
            ...defaultRemoteControlConfig.customReceiverConfig,
            ...userRemoteControlConfig.customReceiverConfig
        }
    };
    processedConfig.remotecontrol = mergedRemoteControlConfig;
    if (processedConfig.cast) {
        console.warn("'cast' is deprecated in playerConfig. Please use 'remotecontrol' with 'GoogleCastRemoteControlConfig' instead.");
        processedConfig.remotecontrol = {
            ...processedConfig.remotecontrol,
            customReceiverConfig: {
                ...processedConfig.remotecontrol.customReceiverConfig,
                ...processedConfig.cast,
                enable: processedConfig.remotecontrol.customReceiverConfig?.enable ??
                    (typeof processedConfig.cast?.enable === 'boolean'
                        ? processedConfig.cast.enable.toString()
                        : processedConfig.cast?.enable)
            }
        };
    }
    if (!processedConfig.logs)
        processedConfig.logs = {
            level: LogLevel.ERROR
        };
    processedConfig.logs.bitmovin = false;
    processedConfig.advertising = {};
    return processedConfig;
}
